import React, { useEffect, useRef } from 'react';
import ChartsEmbedSDK from '@mongodb-js/charts-embed-dom';
import PropTypes from 'prop-types';
import { ObjectId } from 'bson';
import './Chartstyle.css';
import { BASE_URL, CHART_IDS } from './chartConstants';

const BookingMonthly = ({ rolePermission, currentTenantId, currentStation, isExternal }) => {
  const sdk = new ChartsEmbedSDK({
    baseUrl: BASE_URL,
  });
  const chartDiv = useRef(null);

  const filter = {
    tenant: { $eq: new ObjectId(currentTenantId) },
  };

  if (currentStation && currentStation.length > 0) {
    filter['chargers.charging_station'] = { $in: currentStation.map((id) => new ObjectId(id)) };
  }

  if (isExternal) {
    filter['chargers.is_external_charger'] = isExternal;
  }

  const chart = sdk.createChart({
    chartId: CHART_IDS.BOOKING_MONTHLY,
    showAttribution: false,
    padding: 0,
    theme: 'dark',
    background: '$brand-primary',
    rolePermissions: {
      getWidgetBookingCount: rolePermission, // set the role permission
    },
    filter,
    autoRefresh: false,
    maxDataAge: 300,
  });

  BookingMonthly.propTypes = {
    rolePermission: PropTypes.array.isRequired,
    currentTenantId: PropTypes.string.isRequired,
    currentStation: PropTypes.array.isRequired,
    isExternal: PropTypes.bool.isRequired,
  };

  useEffect(() => {
    async function renderChart() {
      try {
        await chart.render(chartDiv.current);
      } catch (err) {
        console.log('Error during Charts rendering.', err);
      }
    }

    renderChart();
  }, [isExternal]);

  return <div className="chart-container" ref={chartDiv}></div>;
};

export default BookingMonthly;
